import { PERSONA } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function PersonaZone() {
  return (
    <section id="people" className="bg-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="主角档案 · 谁在风口浪尖"
          title="这波瓜里的核心人物"
          desc="用代号记录当下被集中讨论的对象，随事件热度自动进榜（示意）。"
          extra={
            <a
              href="#report"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-4 py-2 text-[13px] font-semibold text-secondary-800 transition-colors hover:bg-secondary-50"
            >
              查看完整人物图谱
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
          }
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {PERSONA.map((p, i) => (
            <article
              key={p.name}
              className="group overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70 transition-transform duration-300 hover:-translate-y-1"
            >
              <a href="#report" className="relative block overflow-hidden">
                <img
                  src={p.img}
                  alt={`海角天崖主角档案 ${p.name}`}
                  className="h-[200px] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 grid h-7 w-7 place-items-center rounded-md bg-foreground-950/55 font-heading text-[15px] font-black text-background-50 backdrop-blur">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-primary-600/90 px-2 py-0.5 text-[12px] font-bold text-background-50 backdrop-blur">
                  <i className="ri-fire-fill w-4 h-4 flex items-center justify-center" />
                  {p.heat}
                </span>
              </a>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between gap-2">
                  <h4 className="font-heading text-[17px] font-black text-foreground-950">{p.name}</h4>
                  <span className="whitespace-nowrap rounded bg-accent-100 px-1.5 py-0.5 text-[12px] font-semibold text-accent-900">
                    {p.role}
                  </span>
                </div>
                <p className="mt-2 text-[13px] leading-6 text-foreground-600">{p.desc}</p>
                <a
                  href="#feed"
                  className="mt-3 flex items-center gap-1.5 text-[13px] font-semibold text-primary-600 transition-colors hover:text-primary-700"
                >
                  去翻这个人身上的瓜
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}